{
  "title": "Sécurité",
  "description": "Gérez votre mot de passe, l'authentification à deux facteurs et les sessions actives.",

  "passwordTitle": "Changer le mot de passe",
  "passwordDescription": "Utilisez un mot de passe fort et unique pour protéger votre compte.",
  "currentPasswordLabel": "Mot de passe actuel",
  "newPasswordLabel": "Nouveau mot de passe",
  "confirmPasswordLabel": "Confirmer le nouveau mot de passe",
  "passwordHelper": "Utilisez au moins 8 caractères.",
  "changePassword": "Mettre à jour le mot de passe",
  "passwordChanged": "Mot de passe mis à jour",
  "passwordChangedDescription": "Votre mot de passe a été changé.",
  "passwordError": "Nous n'avons pas pu changer votre mot de passe.",
  "passwordErrorDescription": "Vérifiez votre mot de passe actuel et réessayez.",

  "twoFactorTitle": "Authentification à deux facteurs",
  "twoFactorDescription": "Ajoutez une seconde étape à la connexion pour plus de protection.",
  "twoFactorDisabled": "Non activée",
  "twoFactorEnabled": "Activée",
  "twoFactorHint": "Utilisez une application d'authentification pour générer des codes à usage unique.",
  "enableTwoFactor": "Activer le double facteur",
  "disableTwoFactor": "Désactiver le 2FA",
  "regenerateCodes": "Régénérer les codes",

  "setupDialogTitle": "Configurer l'authentification à deux facteurs",
  "setupDialogDescription": "Scannez le QR code avec votre application d'authentification, puis saisissez le code à 6 chiffres pour confirmer.",
  "qrAlt": "QR code pour votre application d'authentification",
  "secretLabel": "Ou saisissez cette clé manuellement",
  "verifyCodeLabel": "Code à 6 chiffres",
  "verify": "Vérifier et activer",
  "verifyError": "Ce code ne correspond pas.",
  "verifyErrorDescription": "Vérifiez votre application d'authentification et réessayez.",
  "setupError": "Nous n'avons pas pu démarrer la configuration.",
  "setupErrorDescription": "Réessayez dans un instant.",

  "recoveryTitle": "Enregistrez vos codes de récupération",
  "recoveryDescription": "Conservez-les en lieu sûr. Chaque code fonctionne une seule fois si vous perdez l'accès à votre authentificateur. Ils ne seront plus affichés.",
  "copyCodes": "Copier les codes",
  "downloadCodes": "Télécharger les codes",
  "codesCopied": "Codes de récupération copiés",
  "recoveryDone": "J'ai enregistré mes codes",

  "passwordPromptLabel": "Confirmez avec votre mot de passe",
  "disableConfirmTitle": "Désactiver l'authentification à deux facteurs ?",
  "disableConfirmBody": "Votre compte ne reposera plus que sur votre mot de passe. Saisissez votre mot de passe pour confirmer.",
  "disableConfirm": "Désactiver le 2FA",
  "twoFactorDisabledToast": "Double facteur désactivé",
  "twoFactorDisabledToastDescription": "L'authentification à deux facteurs est maintenant désactivée.",
  "disableError": "Nous n'avons pas pu désactiver le double facteur.",
  "regenerateConfirmTitle": "Régénérer les codes de récupération ?",
  "regenerateConfirmBody": "Vos codes de récupération actuels cesseront de fonctionner. Saisissez votre mot de passe pour confirmer.",
  "regenerateConfirm": "Régénérer les codes",
  "regenerateError": "Nous n'avons pas pu régénérer vos codes.",

  "sessionsTitle": "Sessions actives",
  "sessionsDescription": "Appareils actuellement connectés à votre compte.",
  "sessionsEmptyTitle": "Aucune autre session active",
  "sessionsEmptyDescription": "Lorsque vous vous connectez depuis un autre appareil, il apparaîtra ici.",
  "currentSession": "Actuelle",
  "unknownDevice": "Appareil inconnu",
  "signedInAt": "Connecté le {{date}}",
  "ipLabel": "IP {{ip}}",
  "revoke": "Révoquer",
  "revokeConfirmTitle": "Déconnecter cette session ?",
  "revokeConfirmBody": "Cet appareil sera déconnecté et devra se reconnecter.",
  "revokeConfirm": "Déconnecter",
  "sessionRevoked": "Session révoquée",
  "sessionRevokedDescription": "Cet appareil a été déconnecté.",
  "revokeError": "Nous n'avons pas pu révoquer cette session.",
  "revokeErrorDescription": "Réessayez dans un instant.",
  "sessionsError": "Nous n'avons pas pu charger vos sessions.",

  "passwordRequired": "Saisissez votre mot de passe actuel.",
  "passwordTooShort": "Utilisez au moins 8 caractères.",
  "passwordMismatch": "Les nouveaux mots de passe ne correspondent pas.",
  "codeRequired": "Saisissez le code à 6 chiffres.",
  "passwordPromptRequired": "Saisissez votre mot de passe pour confirmer."
}
